import SignIn from "../Containers/SignIn/SignIn";

const SignInPage = () => {
  return <SignIn />;
};

export default SignInPage;
